export default __webpack_public_path__ + "static/media/ios-following.9699f0ba.svg";